/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Aceptar y continuar',
    APPROVE: 'Aprobar',
    CANCEL: 'Cancelar',
    SAVE: 'Guardar'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'He leído y acepto los Términos y Condiciones',
    ACCEPT_TERMS_DESCRIPTION:
      'Antes de acceder a la plataforma Prozis Partnership, por favor revisa y acepta los Términos y Condiciones del Programa de Influencers de Prozis.',
    ACCEPT_TERMS_NAV_TITLE: 'Términos y Condiciones',
    ACCEPT_TERMS_SCROLL_HINT: 'Lee hasta el final para continuar.',
    DASHBOARD: 'Panel de control',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Notamos que no tienes las notificaciones activas, para poder seguir usando la aplicación necesitamos que actives las notificaciones.',
    ENABLE_NOTIFICATIONS_LINK: 'Puedes activar las notificaciones aquí.',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Notificaciones',
    ENABLE_NOTIFICATIONS_TITLE:
      'Activa las notificaciones para poder continuar',
    HOME: 'Inicio',
    INSTALL_PROZIS_APP: 'Instalar la aplicación Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Instale nuestra aplicación móvil para seguir accediendo a todas las funciones.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Instalar aplicación',
    LOGOUT: 'Cerrar sesión',
    NOT_FOUND: 'Sin resultados',
    OR: 'O',
    OR_SCAN_QR_CODE: 'O escanee el código QR',
    SCAN_QR_CODE: 'Escanee el código QR con su dispositivo móvil',
    TODOS: 'Todos',
    UNAUTHORIZED_DESCRIPTION_1:
      'Consulte con su gerente para obtener permisos de acceso.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Después de la verificación, intente iniciar sesión nuevamente.',
    UNAUTHORIZED_NAV_TITLE: 'Acceso denegado',
    UNAUTHORIZED_TITLE: 'Sin permiso de acceso'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
